import { Component, inject, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuthButtonComponent } from '@processpuzzle/auth';
import { AppTitleComponent, LanguageSelectorComponent, NavMenuComponent } from '@processpuzzle/base-widget';
import { LayoutService, NavigateBackComponent } from '@processpuzzle/util';

/**
 * The application bar: logo, sidenav toggle, title, language selector and the sign-in button.
 *
 * Deliberately thinner than the testbed's. It carries no design-mode toggle, no like or share
 * button, and so no `provideAppPropertyStore()` — that store is what pulls Firestore into an
 * application, and this one talks to nothing but its own REST backend.
 *
 * The title and the handset menu are base-widget's `app-title` and `nav-menu`, reading the name and
 * the routes from the `APPLICATION_CONTEXT` this application provides — see
 * `navigation/application-context.ts`. On a handset the sidenav renders nothing, so `nav-menu`,
 * which shows itself on small screens only, stands in for it.
 */
@Component({
  selector: 'app-header',
  imports: [
    AppTitleComponent,
    AuthButtonComponent,
    LanguageSelectorComponent,
    MatIcon,
    MatIconButton,
    MatToolbar,
    NavigateBackComponent,
    NavMenuComponent,
    NgOptimizedImage,
    RouterLink,
  ],
  templateUrl: 'header.component.html',
  styleUrl: 'header.component.scss',
})
export class HeaderComponent {
  readonly layoutService = inject(LayoutService);
  readonly router = inject(Router);
  readonly toggleSideNav = output<undefined>();

  async onLogoClick() {
    await this.router.navigateByUrl('/');
  }

  async onLogoKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ' || event.code === 'Space') {
      event.preventDefault();
      await this.onLogoClick();
    }
  }

  sidenavToggle() {
    this.toggleSideNav.emit(undefined);
  }
}
